export const uniqueArr = (input: Array<any>): Array<any> => {
  const arr = [...input]
  return Array.from(new Set(arr))
}

export interface ArrayUtils {
  uniqueArr: typeof uniqueArr
}
